module.exports = __webpack_public_path__ + "static/media/casa-reina-3bed.6b8211cb.jpg";